import React from 'react';

const Arrow = () => (
  <svg
    width="8"
    height="13"
    viewBox="0 0 8 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Shape"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.589996 11.34L5.17 6.75L0.589996 2.16L2 0.75L8 6.75L2 12.75L0.589996 11.34Z"
    />
  </svg>
);

export default Arrow;
